export default {
  setBreadCrumbs(state, payload) {
    state.breadCrumbs = payload;
  },
};
